<div *ngIf="traaqrTag">
  <div fxLayout="row" *ngIf="!traaqrTag.embedDetected && !detected">
    <mat-card class="card-widget mat-green-50 traaqr-card" fxFlex="100%">
      <div mat-card-widget>
        <button mat-mini-fab class="shadow-none mat-red color-white">
          <mat-icon>priority_high</mat-icon>
        </button>
        <div class="card-widget-warn-text">
          <h2 mat-card-widget-title>Install Tracking Tag</h2>
          <p>
            Your Tracking Tag embed code is not installed on your website. Follow the instructions below to install your
            code.
          </p>
        </div>
      </div>
    </mat-card>
  </div>

  <div fxLayout="row" *ngIf="traaqrTag.embedDetected || detected">
    <mat-card class="card-widget mat-green-50 traaqr-card" fxFlex="100%">
      <div mat-card-widget>
        <button mat-mini-fab class="shadow-none mat-green color-white">
          <mat-icon>done_outline</mat-icon>
        </button>
        <div class="card-widget-text card-widget-warn-text">
          <h2 mat-card-widget-title>Tracking Tag Installed</h2>
          <p>
            Your Tracking Tag embed code is successfully installed on your website
          </p>
        </div>
      </div>
    </mat-card>
  </div>

  <div fxLayout="row" fxLayoutAlign="center">
    <div fxFlex="85">
      <mat-card class="traaqr-card">
        <mat-card-header>
          <mat-card-title>Installation Instructions</mat-card-title>
        </mat-card-header>
        <hr />
        <mat-card-content>
          <p>
            You'll need to add the Tracking Tag embed code to your website. The process is similar to a manual install
            of Google Analytics.
          </p>
          <mat-list>
            <mat-list-item>
              <mat-icon mat-list-icon>content_copy</mat-icon>
              <p matLine>Copy the entire embed code below.</p>
            </mat-list-item>
          </mat-list>
          <mat-card class="traaqr-card embed-code-card">
            <mat-card-content>
              <code>{{ embedCode }}</code>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button color="primary" class="small-button" (click)="copyEmbedCode()">
                Copy Embed Code
              </button>
            </mat-card-actions>
          </mat-card>
          <mat-list>
            <mat-list-item>
              <mat-icon mat-list-icon>content_paste</mat-icon>
              <p matLine>
                Paste the code into <b>every</b> page on your site, inside the <code>&lt;head&gt;</code> section - in a
                global header, if possible.
              </p>
              <p matLine>
                <a class="mat-text-primary" target="_new" href="https://codex.wordpress.org/Using_Javascript"
                  >Click here</a
                >
                for an example of how you can do this via the global <code>header.php</code> on a Wordpress site.
              </p>
              <p style="padding-top: 5px" matLine>
                If you are using Google Tag Manager, you can find installation instructions
                <a
                  class="mat-text-primary"
                  target="_new"
                  href="https://www.myadvocado.com/help/getting-started/embed-code"
                  >here</a
                >
              </p>
            </mat-list-item>
            <mat-list-item>
              <mat-icon mat-list-icon>web</mat-icon>
              <p matLine>You will have to visit at least one page on your site so that we can detect the embed code.</p>
              <p matLine>Visit your site, then come back to this page to refresh your status</p>
            </mat-list-item>
            <mat-list-item>
              <mat-icon mat-list-icon>refresh</mat-icon>
              <p matLine>
                After visiting your site, click the <b>Refresh Embed Status</b> button to check if your embed code is
                installed correctly.
              </p>
            </mat-list-item>
          </mat-list>

          <p>Having trouble? Send an email to support@myadvocado.com</p></mat-card-content
        >

        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="refreshData()">Refresh Embed Status</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
